/*
 * Copyright (c) 2023 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import ConfirmModal, {
  ConfirmModalProps
} from '../../../../client/js/components/modals/ConfirmModal'

function UseEstateInfoModal (props: Omit<ConfirmModalProps, 'message'>) {
  const { onClose, onConfirm, ...others } = props
  const intl = useIntl()
  return (
    <ConfirmModal
      centered
      closeOnClickOutside={false}
      onClose={onClose}
      onConfirm={onConfirm}
      message={(
        <>
          <p>
            {intl.formatMessage({
              id: 'do_you_want_to_use_estate_info',
              defaultMessage: 'Voulez-vous utiliser les informations du bien ?'
            })}
          </p>
          <ul>
            <li>
              {intl.formatMessage({
                id: 'furnished',
                defaultMessage: 'Meublé'
              })}
            </li>
            <li>
              {intl.formatMessage({
                id: 'equipped',
                defaultMessage: 'Équipé'
              })}
            </li>
            <li>
              {intl.formatMessage({
                id: 'charges',
                defaultMessage: 'Charges'
              })}
            </li>
          </ul>
        </>
      )}
      {...others}
    />
  )
}

export default UseEstateInfoModal
